import React, { useState, useRef, useEffect } from 'react';

const PackageSearch = ({ packages, selectedPackageId, onSelect }) => {
  const [idInput, setIdInput] = useState('');
  const [nameSearch, setNameSearch] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  const selected = packages.find(p => p.id === selectedPackageId);

  // Close dropdown on click outside
  useEffect(() => {
    const handleClick = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const handleIdChange = (e) => {
    const val = e.target.value;
    setIdInput(val);
    if (!val) return;
    const id = parseInt(val, 10);
    if (isNaN(id)) return;
    const match = packages.find(p => p.id === id);
    if (match) {
      onSelect(match.id);
      setNameSearch('');
      setShowDropdown(false);
    }
  };

  const handleNameChange = (e) => {
    const val = e.target.value;
    setNameSearch(val);
    setShowDropdown(val.length > 0);
  };

  const handleSelectPackage = (pkg) => {
    onSelect(pkg.id);
    setIdInput('');
    setNameSearch('');
    setShowDropdown(false);
  };

  const handleClear = () => {
    onSelect(null);
    setIdInput('');
    setNameSearch('');
  };

  const filtered = nameSearch.length > 0
    ? packages.filter(p => {
        const q = nameSearch.toLowerCase();
        return (p.slug || '').toLowerCase().includes(q) ||
               (p.name || '').toLowerCase().includes(q) ||
               String(p.id).includes(q);
      })
    : [];

  return (
    <div style={{ display: 'flex', gap: 8, alignItems: 'flex-end' }}>
      {/* Package ID input */}
      <div>
        <label style={{ display: 'block', fontSize: 11, color: '#888', marginBottom: 2 }}>Pkg ID</label>
        <input
          type="number"
          value={idInput}
          onChange={handleIdChange}
          placeholder="#"
          style={{
            width: 70, padding: '6px 8px', border: '1px solid #ccc',
            borderRadius: 4, fontSize: 14, background: '#fff'
          }}
        />
      </div>

      {/* Name/slug search */}
      <div ref={dropdownRef} style={{ position: 'relative' }}>
        <label style={{ display: 'block', fontSize: 11, color: '#888', marginBottom: 2 }}>Search by name or slug</label>
        <input
          type="text"
          value={nameSearch}
          onChange={handleNameChange}
          onFocus={() => { if (nameSearch.length > 0) setShowDropdown(true); }}
          placeholder="Type to search..."
          style={{
            width: 280, padding: '6px 10px', border: '1px solid #ccc',
            borderRadius: 4, fontSize: 14, background: '#fff'
          }}
        />
        {showDropdown && filtered.length > 0 && (
          <div style={{
            position: 'absolute', top: '100%', left: 0, right: 0,
            background: '#fff', border: '1px solid #ccc', borderRadius: 4,
            zIndex: 1000, maxHeight: 250, overflow: 'auto',
            boxShadow: '0 4px 12px rgba(0,0,0,.15)'
          }}>
            {filtered.slice(0, 30).map(p => (
              <div
                key={p.id}
                onClick={() => handleSelectPackage(p)}
                style={{
                  padding: '6px 10px', cursor: 'pointer', fontSize: 13,
                  borderBottom: '1px solid #f5f5f5'
                }}
                onMouseEnter={e => e.currentTarget.style.background = '#f0f7ff'}
                onMouseLeave={e => e.currentTarget.style.background = '#fff'}
              >
                <div style={{ fontWeight: 500 }}>{p.slug || p.name}</div>
                <div style={{ fontSize: 11, color: '#888' }}>
                  ID: {p.id} | {p.season || 'no season'} | {p.name}
                </div>
              </div>
            ))}
          </div>
        )}
        {showDropdown && nameSearch.length > 0 && filtered.length === 0 && (
          <div style={{
            position: 'absolute', top: '100%', left: 0, right: 0,
            background: '#fff', border: '1px solid #ccc', borderRadius: 4,
            zIndex: 1000, boxShadow: '0 4px 12px rgba(0,0,0,.15)',
            padding: '8px 10px', color: '#999', fontSize: 13
          }}>
            No matching packages
          </div>
        )}
      </div>

      {/* Selected package chip */}
      {selected && (
        <div style={{
          display: 'flex', alignItems: 'center', gap: 6,
          background: '#e3f2fd', border: '1px solid #90caf9',
          borderRadius: 4, padding: '4px 10px', fontSize: 13, whiteSpace: 'nowrap'
        }}>
          <span style={{ fontWeight: 500 }}>{selected.slug || selected.name}</span>
          <span style={{ color: '#666' }}>#{selected.id}</span>
          <button
            onClick={handleClear}
            style={{
              background: 'none', border: 'none', cursor: 'pointer',
              fontSize: 16, color: '#666', padding: '0 2px', lineHeight: 1
            }}
          >
            &times;
          </button>
        </div>
      )}
    </div>
  );
};

export default PackageSearch;
